import React from 'react';
import { RatingsAndReviewMetric } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewMetricTypes';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';

const fields = [
  {
    name: RatingsAndReviewMetric.PARENT_WEEKLY_RATING_VOLUME,
    displayName: 'Rating Volume'
  },
  {
    name: 'retailSales',
    displayName: 'retailSales',
    displayInTable: false
  },
  {
    name: RatingsAndReviewMetric.PARENT_WEEKLY_RATING,
    displayName: 'Avg Star Rating'
  },
  {
    name: RatingsAndReviewMetric.WEEKLY_REVIEW_VOLUME,
    displayName: 'Review Volume'
  },
  {
    name: RatingsAndReviewMetric.WEEKLY_REVIEW_RATING,
    displayName: 'Review Rating'
  }
];

export const WeeklyRatingTable = () => {
  const weekEndingFields = fields.map(removeComparisonFormatter);

  return (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Ratings by Week'
      }}
      indexName={BEACON_INDEX_NAMES.RATINGS_REVIEWS_METRICS_V2}
      sortFieldName="retailSales"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  );
};
